// @flow

import { updateCustomTranslations } from '../../lib/i18n';
import { changeTheme } from '../../theme-config';

export type ThemeActionsType = {|
  type: 'UPDATE_THEME',
  payload: {| theme: string |},
|};

export const toggleTheme = (): ThemeActionsType => {
  const theme = changeTheme();
  updateCustomTranslations();

  return {
    type: 'UPDATE_THEME',
    payload: { theme },
  };
};
